import { axios } from '@/lib/axios';
import { PostComment } from "@/types/ticket";

export const getTicketUrl = ( pathname: string ) => {
  return axios.get('/api/v1/dataTickets/getTicketUrl', {
    params: { pathname }
  })
}

export const postComment = ( postData: PostComment ) => {
  return axios.post('/api/v1/dataTickets/postComment', postData)
}

export const getTicketDestinationBy = (project_id: number) => {
  return axios.get("/api/v1/ticketDestination/getByProjectId", {
    params: {
      project_id,
    },
  });
};
